const { deactivate } = require('gui');
const { getTranslationDictionary } = require('core');
const newPackageEventPresenter = require('./packageEventPresenter');
const collapsibleRegionPresenter = require('./collapsibleRegionPresenter');

module.exports = function packageEventsPresenter(eventsDto = []) {
    const view = require('./packageEventsPresenter.tpl.html');
    const c = {};
    const deactivator = deactivate();
    const translationDictionary = getTranslationDictionary();
    const headerString = translationDictionary.packageEvents;
    const eventsRegionPresenter = collapsibleRegionPresenter(headerString, { collapsed: true });

    c.activate = function(region) {
        if(eventsDto.length <= 0)
            return;

        eventsRegionPresenter.activate(region);
        view.activate(eventsRegionPresenter.contentRegion());
        deactivator.add(eventsRegionPresenter);
        deactivator.add(view);

        var packages = {};
        eventsDto.forEach(function(event){
            var eventCode = event.eventCode;
            var eventPlace = event.place;
            var ticks = event.ticks;
            var tripId = event.tripId;
            if(!packages[eventCode + eventPlace + tripId]){
                packages[eventCode + eventPlace + tripId] = [];
                packages[eventCode + eventPlace + tripId].ticks = 0;
            }
            packages[eventCode + eventPlace + tripId].push(event);
            if(packages[eventCode + eventPlace + tripId].ticks < ticks) {
                packages[eventCode + eventPlace + tripId].ticks = ticks;
                packages[eventCode + eventPlace + tripId].event = event;
            }
        })

        for(var eventName in packages){
            var events = packages[eventName];
            var packageEvent = packages[eventName].event;

            events.forEach(function(innerPackageEvent){
                if(innerPackageEvent.lastConfirmed)
                    packageEvent.lastConfirmed = true;
                if(!packageEvent.innerPackages)
                    packageEvent.innerPackages = [];
                packageEvent.innerPackages.push(innerPackageEvent);
            });

            let presenter = newPackageEventPresenter(packageEvent);
            presenter.activate(view.eventsRegion);
            deactivator.add(presenter);
        }
    };

    c.deactivate = function() {
        deactivator();
    }

    return c;
};